<template>
  <div class="adn-message">
    <div v-if="state.shouldDisplayAlert">
      <adn-alert :icon="icon" :kind="kind">{{ title }}</adn-alert>
    </div>
    <span class="adn-message-text">
      <slot></slot>
    </span>
    <div v-if="state.hasActions" class="adn-message-cta">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, reactive } from 'vue'
import AdnAlert from '../AdnAlert/AdnAlert.vue'

export default defineComponent({
  name: 'AdnMessage',
  components: {
    AdnAlert,
  },
  props: {
    title: String,
    icon: String,
    kind: {
      type: String,
      default: 'info',
    },
  },
  setup(props, context) {
    const state = reactive({
      hasActions: computed(() => !!context.slots.actions),
      shouldDisplayAlert: computed(() => !!props.title || !!props.icon),
    })

    return {
      state,
    }
  },
})
</script>

<style scoped lang="scss">
.adn-message {
  padding: 1.5rem;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.adn-message-text {
  padding-top: 0.5rem;
  padding-left: 3rem;
}

.adn-message-cta {
  padding-top: 2rem;
  text-align: center;
}
</style>
